
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 401.3 401.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341.6 141h-12.2v-21.7c0-23.6-19.1-42.7-42.7-42.7H114.5c-23.6 0-42.7 19.1-42.7 42.7V141H59.7c-4.9 0-8.9 4-8.9 8.9v49.2c0 4.9 4 8.9 8.9 8.9h12.2v106c-4.8 4.3-7.7 10.4-7.7 17.3v16.4c0 12.9 10.4 23.3 23.3 23.3h2.9v23.4c0 3.8 3.1 6.8 6.8 6.8h31.5c3.8 0 6.8-3.1 6.8-6.8V371h130.4v23.4c0 3.8 3.1 6.8 6.8 6.8h31.5c3.8 0 6.8-3.1 6.8-6.8V371h2.9c12.9 0 23.3-10.4 23.3-23.3v-16.4c0-6.9-3-13.1-7.7-17.3V207.9h12.2c4.9 0 8.9-4 8.9-8.9v-49.2c-.1-4.8-4.1-8.8-9-8.8zm-38.6 3.4v105h-90.7v-105H303zM155.4 98.8h90.5c6.3 0 11.4 5.1 11.4 11.4 0 6.3-5.1 11.4-11.4 11.4h-90.5c-6.3 0-11.4-5.1-11.4-11.4 0-6.3 5.1-11.4 11.4-11.4zm-57.1 45.6H189v105H98.3v-105zm40.6 151.8c0 6.2-5 11.2-11.2 11.2h-18.5c-6.2 0-11.2-5-11.2-11.2v-12.5c0-6.2 5-11.2 11.2-11.2h18.5c6.2 0 11.2 5 11.2 11.2v12.5zm123.5 0v-12.5c0-6.2 5-11.2 11.2-11.2h18.5c6.2 0 11.2 5 11.2 11.2v12.5c0 6.2-5 11.2-11.2 11.2h-18.5c-6.2.1-11.2-5-11.2-11.2z"}}),_c('path',{attrs:{"d":"M201.6.9c-5.4-2.3-11.6.1-13.9 5.5l-32.7 75 19.4 8.4 32.7-75c2.3-5.4-.1-11.6-5.5-13.9zm63.8 0c-5.4-2.3-11.6.1-13.9 5.5l-32.7 75 19.4 8.4 32.7-75c2.3-5.4-.2-11.6-5.5-13.9z"}}),_c('path',{attrs:{"d":"M143.6 65.6h113.6v27.1H143.6z"}})])
          )
        }
      }
    